import sort from "./sort";
import byAlphabet from "./byAlphabet";

// [String] -> [String]
const sortAlphabetically = sort(byAlphabet);

export default sortAlphabetically;
